import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import logo from "@/assets/kynn-logo.webp";

export default function SiteHeader() {
  return (
    <>
      <header className="container-kynn pt-8 pb-6 flex items-center justify-between">
        <Link to="/" data-testid="site-header-logo" aria-label="Kynn home">
          <img
            src={logo}
            alt="Kynn"
            style={{ height: "44px", width: "auto", display: "block" }}
          />
        </Link>
        <Link
          to="/admin"
          data-testid="admin-nav-link"
          className="small-caps flex items-center gap-1.5 opacity-60 hover:opacity-100 transition-opacity"
          style={{ color: "#DDBFCF" }}
        >
          Host <ArrowUpRight size={12} />
        </Link>
      </header>
      <div className="hairline container-kynn" />
    </>
  );
}
